import React from 'react';
import { Link } from 'react-router-dom';
interface FooterLink {
  label: string;
  to?: string;
  href?: string;
}
interface FooterColumn {
  title: string;
  links: FooterLink[];
}
const columns: FooterColumn[] = [{
  title: 'Solutions',
  links: [{
    label: 'For Brands',
    to: '/for-brands'
  }, {
    label: 'For Marketing Agencies',
    to: '/for-marketing-agencies'
  }, {
    label: 'For Talent Agencies',
    to: '/list-your-roster'
  }]
}, {
  title: 'Resources',
  links: [{
    label: 'Best Talent Agencies by Category',
    to: '/resources'
  }, {
    label: 'Guides for Brands',
    to: '/resources?tab=guides'
  }]
}, {
  title: 'Company',
  links: [{
    label: 'Home',
    to: '/'
  }, {
    label: 'Case Studies',
    to: '/case-studies'
  }, {
    label: 'Pricing',
    to: '/pricing'
  }, {
    label: 'Login',
    href: 'https://app.zanoplatform.com/sign-in'
  }]
}, {
  title: 'Legal',
  links: [{
    label: 'Privacy Policy',
    to: '/privacy-policy'
  }, {
    label: 'Terms of Service',
    to: '/terms-of-service'
  }, {
    label: 'Cookie Policy',
    to: '/cookie-policy'
  }]
}];
const socials = [{
  label: 'Zano on LinkedIn',
  href: 'https://il.linkedin.com/company/zanoplatformforagencies',
  logo: 'https://cdn.magicpatterns.com/uploads/x8RWVycUHFvXFpEPSTUaiu/download_(17).png',
  logoClass: 'h-5 w-5'
}, {
  label: 'Zano on YouTube',
  href: 'https://www.youtube.com/@zanoplatform',
  logo: 'https://cdn.magicpatterns.com/uploads/oAjtAv3FmAiEVBWNmuz572/download_(16).png',
  logoClass: 'h-4 w-auto'
}];
const linkClass = 'text-sm text-gray-500 hover:text-zano-pink transition-colors';
export const Footer = () => {
  return <footer className="bg-white border-t border-gray-100 pt-14 pb-10" data-id="element-433" data-mp="cus0p3kgj0eh">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-434" data-mp="qt8grl47m39a">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-[minmax(0,1fr)_minmax(0,2fr)]" data-id="element-435" data-mp="qtrsgk39nvev">
          {/* Brand + contact */}
          <div data-id="element-436" data-mp="tv4iroyaqfyo">
            <Link to="/" className="inline-flex items-center" aria-label="Zano home" data-id="element-437" data-mp="tvmordarg8js">
              <img src="https://cdn.magicpatterns.com/uploads/gbY7Dn8gGgHtYDAdDbncPd/zano_logo_full1.png" alt="Zano" className="h-6 w-auto" data-id="element-438" data-mp="ytxzdq8vqn32" />
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-gray-500" data-id="element-439" data-mp="18k92xboniu9f">
              The discovery layer for represented creators.
            </p>

            <address className="mt-8 not-italic" data-id="element-440" data-mp="1cnyp5uhuszra">
              <h3 className="mb-3 text-xs font-semibold uppercase tracking-wider text-zano-charcoal" data-id="element-441" data-mp="1hjnw4iw7dixm">
                Contact
              </h3>
              <p className="text-sm font-medium text-zano-charcoal" data-id="element-442" data-mp="1mhxqira3sfi6">
                Zano Media Technologies LTD
              </p>
              <p className="mt-1 text-sm text-gray-500" data-id="element-443" data-mp="3obolfarw99ex">
                A company registered in Israel.
              </p>
              <p className="mt-1 text-sm text-gray-500" data-id="element-444" data-mp="3tb9onxe3k3xg">
                Email:{' '}
                <a href="mailto:support@zanoplatform.com" className="text-gray-600 underline-offset-2 transition-colors hover:text-zano-pink hover:underline" data-id="element-445" data-mp="2afdgt88id0mo">
                  support@zanoplatform.com
                </a>
              </p>
            </address>

            <ul className="mt-6 flex items-center gap-3" aria-label="Social media" data-id="element-446" data-mp="1wp0b7cj39y0i">
              {socials.map(({
              label,
              href,
              logo,
              logoClass
            }) => <li key={href} data-id="element-447" data-mp="2pceahha9f5ns">
                  <a href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="flex h-9 items-center rounded-md opacity-90 transition-opacity hover:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-zano-pink focus-visible:ring-offset-2" data-id="element-448" data-mp="2pdfonumko89q">
                    <img src={logo} alt="" className={`${logoClass} object-contain`} data-id="element-449" data-mp="13y9yqtlgb9gn" />
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Link columns */}
          <div className="grid grid-cols-2 gap-8 gap-y-10 sm:grid-cols-4" data-id="element-450" data-mp="2wo0ukn90radx">
            {columns.map(col => <nav key={col.title} aria-label={`${col.title} links`} data-id="element-451" data-mp="2iww0s1sc1cbi">
                <h3 className="mb-4 text-xs font-semibold uppercase tracking-wider text-zano-charcoal" data-id="element-452" data-mp="2nv78a5v5naqk">
                  {col.title}
                </h3>
                <ul className="space-y-3" data-id="element-453" data-mp="3flbqbxvfzlom">
                  {col.links.map(link => <li key={link.label} data-id="element-454" data-mp="3fizcnwwpvxhd">
                      {link.to ? <Link to={link.to} className={linkClass} data-id="element-455" data-mp="31laoog7csa83">
                          {link.label}
                        </Link> : <a href={link.href} target="_blank" rel="noopener noreferrer" className={linkClass} data-id="element-456" data-mp="1q5cci3gvp82n">
                          {link.label}
                        </a>}
                    </li>)}
                </ul>
              </nav>)}
          </div>
        </div>

        <div className="mt-12 border-t border-gray-100 pt-8 text-sm text-gray-400" data-id="element-457" data-mp="1wk9qgwfp3qz0">
          © 2026 Zano Media Technologies LTD. All rights reserved.
        </div>
      </div>
    </footer>;
};